import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/BillingInformation.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useBillingInformationQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useBillingInformationLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getBillingInformationQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getBillingInformation
  const [getBillingInformationQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getBillingInformationQuery, ...result };
};

export const useBillingInformationPromiseQuery = () => {
  const client = useApolloClient();

  const getBillingInformation = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getBillingInformation };
};
